import { InputAdornment, TextField } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function ModifierValue() {
    const { target, refresh } = useBoundContext()
    const isPercent = target.type === "percentage"
    return (
        <TextField
            label="Value"
            value={target.value ?? ""}
            onChange={handleChange}
            onWheel={(e) => e.target.blur()}
            inputProps={{ inputMode: "decimal" }}
            InputProps={{
                endAdornment: isPercent ? <InputAdornment position="end">%</InputAdornment> : null,
            }}
            fullWidth
            helperText={
                isPercent
                    ? "Enter a whole number (e.g. 15 for 15%). Negative values reduce the total."
                    : "Enter a monetary amount. Negative values reduce the total."
            }
        />
    )

    function handleChange(e) {
        target.value = e.target.value
        refresh()
    }
}
